export default __webpack_public_path__ + "static/media/a2-4-11.dceef003.jpg";